export default import.meta.ROLLDOWN_FILE_URL_AnXc1NqCYAMHqoYYbq_DbA